import { Component, OnInit, Input } from '@angular/core';
import { CompanyAuditTemplateDetailsModel } from 'app/company/models/company-audit-template-details.model';
import { CompanyService } from 'app/company/services/company.service';
import { Result } from 'app/core/models/result';

@Component({
  selector: 'app-company-audit-templates-list',
  templateUrl: './company-audit-templates-list.component.html',
  styleUrls: ['./company-audit-templates-list.component.css']
})
export class CompanyAuditTemplatesListComponent implements OnInit {
    @Input() companyId: string;
    selectedAuditTemplate: string;
    errors: string[];
    companyAuditTemplates: CompanyAuditTemplateDetailsModel[];

    constructor(
        private companyService: CompanyService
    ) { }

    ngOnInit() {
        this.load();
    }

    load(): void {
        this.companyService.getCompanyAuditTemplates(this.companyId).subscribe(
            result => {
                this.companyAuditTemplates = result;
            },
            error => this.errors = error.errorList
        );
    }

    deleteAuditTemplate(): void {
        this.companyService.deleteAuditTemplate(this.companyId, this.selectedAuditTemplate).subscribe(
            result => this.load(),
            error => this.errors = (<Result>error).errorList
        );
    }


    companyUserAdded($event: string): void {
        this.load();
    }

}
